<template>
    <div>
        <v-navigation-drawer v-model="chapter" fixed app temporary>            
            <v-toolbar color="deep-purple darken-1" flat style="position: sticky; top: 0; z-index: 10;">
            <v-list>
                <v-list-tile>
                <v-list-tile-title class="title" >
                    Chapter List
                </v-list-tile-title>
                </v-list-tile>
            </v-list>
            </v-toolbar>
            <v-divider></v-divider>
            <v-list dense class="pt-0">
            <v-list-tile
                v-for="item in items"
                :key="item.title"
                @click="onward = !onward"
            >
                <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <div id="dyn-container">
            <v-tooltip bottom nudge-top="10">
                <v-btn slot="activator" fab color="grey darken-2" class="explore elevation-2" @click="chapter = !chapter"><img src="@/assets/svg/026-flag.svg" width="100%" height="100%" alt=""></v-btn>
                <span>chapters</span>
            </v-tooltip> 
            <v-tooltip bottom nudge-top="10">
                <v-btn slot="activator" fab color="grey darken-2" class="option elevation-2" @click="chapter = !chapter"><img src="@/assets/svg/018-options.svg" width="100%" height="100%" alt=""></v-btn>
                <span>options</span>
            </v-tooltip> 
            <v-tooltip bottom nudge-top="10">
                <v-btn slot="activator" fab color="grey darken-2" class="share elevation-2" @click="chapter = !chapter"><img src="@/assets/svg/024-share.svg" width="100%" height="100%" alt=""></v-btn>
                <span>share this</span>
            </v-tooltip>
            <!-- <div class="vr-line"></div> -->
            <h1 class="header" :class="{headerFade: isActive, header: !isActive}">{{content.data.novel}}</h1>        
            <div class="body">Content is not ready yet :(<br><br>
                <b>Please don't mind that rate thingy below. We were experimenting with future feature but too lazy to tidy it up.</b>
            </div>
            <div class="rate">
                <v-layout>
                    <v-flex >
                        <h3 class="rate-number">88<span style="font-size: 64%">%</span></h3>
                        <h4 class="rate-desc">people thought this chapter well done</h4>
                    </v-flex>                    
                    <v-flex class="submit">
                        <div class="submit-desc">disagree?</div>
                        <v-btn color="deep-purple" style="color: #fffa;">RATE YOUR SCORE</v-btn>                    
                    </v-flex>
                </v-layout>
            </div>
        </div>
    </div>    
</template>

<script>
const axios = require('axios')

export default {
  data () {
    return {
      content: null,
      isActive: false,
      chapter: false,
      items: [
        { title: 'PROLOGUE', icon: 'dashboard' },
        { title: 'PROLOGUE', icon: 'dashboard' },
        { title: 'PROLOGUE', icon: 'dashboard' },
        { title: 'PROLOGUE', icon: 'dashboard' },
        { title: 'About', icon: 'question_answer' }
      ],
      right: null
    }
  },
  mounted () {
    axios
      .get('static/chapters/chapter.json')
      .then(response => (this.content = response))
      .then(this.isActive = true)
      .then(this.$Progress.finish())
  },
  created () {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start()
    //  hook the progress bar to start before we move router-view
  }
}
</script>

<style lang="scss" scoped>
    #dyn-container{
        max-width: 700px;
        margin: 0 auto;
        padding: 20px;
        font-size: 1.2rem;
    }
    .header{        
        margin-top: 140px;
        margin-bottom: 34px;      
        opacity: 0;
        transform: translateY(-20px);
        transition: all 3s ease-in;  
    }
    .headerFade{
        margin-top: 140px;
        margin-bottom: 34px;
        opacity: 1;
        transform: translateY(0);
    }
    .chapter{
        color: #9575CD;
    }
    .body{
        font-family: 'EB Garamond', serif;
        opacity: 0.8;
    }
    .v-btn__content img{
        filter: grayscale(0.4);
        width: 48px;
        transition: all 0.2s cubic-bezier(.87,-.41,.19,1.44);
    }
    .v-btn__content:hover > img{
        width: 64px;
        margin-top: -8px;
        filter: grayscale(0);
    }
    $top: 25%;
    .explore,
    .option,
    .share{
        position: fixed !important;        
        left: calc(50vw - 428px);
        font-size: 12px;
        z-index: 2;
    }
    .explore{
        top: $top;
    }
    .option{
        top: calc(25% + 100px);
    }
    .share{
        top: calc(25% + 200px);
    }
    .rate{
        background: #0002;        
        margin-top: 150px;
        margin-bottom: 65px;
        width: 100%;
        border-radius: 4px;
        padding-bottom: 5px;
    }
    .rate .rate-number{
        font-size: 15rem;
        color: goldenrod;  
        line-height: 7rem; 
        transform: translateY(-4px);     
    }
    .rate .rate-desc{
        margin-left: 18px;
        opacity: 0.75;
    }
    .rate .submit{
        display: block;
        position: relative;
        right: 0;
        top: 40px;
        text-align: center;
    }
    .submit-desc{
        font-weight: 400;
        font-size: 1rem;
        font-family: 'Quicksand', sans-serif;
        color:rgb(174, 161, 199);
    }
    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
    }
    .v-navigation-drawer::-webkit-scrollbar-button{
        background:#9575CD;
    }
    .v-navigation-drawer::-webkit-scrollbar-track{
        width: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/dynamic.vue